import { Button, Text } from '@react-spectrum/s2';
import ChevronRight from '@react-spectrum/s2/icons/ChevronRight';
import { useCallback, useState } from 'react';

import { TypewriterOnce } from '../components/TypewriterOnce';

type OnlinePresenceScreenProps = {
	onContinue: () => void;
	ready: boolean;
};

export const OnlinePresenceScreen = ({
	onContinue,
	ready,
}: OnlinePresenceScreenProps) => {
	const [typingDone, setTypingDone] = useState(false);
	const handleTypingDone = useCallback(() => setTypingDone(true), []);

	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="w-full max-w-[760px] px-8">
				<h2
					className="mb-10"
					style={{
						fontSize: 'clamp(26px, 4vw, 40px)',
						fontWeight: 700,
						letterSpacing: '-0.02em',
						lineHeight: 1.15,
						color: 'var(--text-primary)',
					}}
				>
					<TypewriterOnce
						text="Great. Next let's look at your online presence."
						onDone={handleTypingDone}
					/>
				</h2>

				<div
					style={{
						opacity: typingDone ? 1 : 0,
						transition: 'opacity 400ms ease',
						pointerEvents: typingDone ? 'auto' : 'none',
					}}
				>
					<Button
						variant="primary"
						staticColor="black"
						fillStyle="fill"
						size="L"
						isDisabled={!ready}
						onPress={onContinue}
					>
						<Text>Continue</Text>
						<ChevronRight />
					</Button>

					{!ready && (
						<p
							className="mt-4"
							style={{
								fontSize: 14,
								color: 'var(--text-muted)',
							}}
						>
							Please wait a few seconds while we get everything ready…
						</p>
					)}
				</div>
			</div>
		</div>
	);
};
